"use client";
import { usePlayer } from "@packages/media";
import type { PlayRequestItem } from "@packages/sdk";

import type { HallowElementProps } from "../../../types/hallowElementProps.types";

type PlayLinkProps = HallowElementProps<"a"> & {
  playable: PlayRequestItem;
};

export const PlayLink = ({
  playable,
  href,
  onClick,
  ...props
}: PlayLinkProps) => {
  const player = usePlayer();
  return (
    <a
      href={href}
      onClick={(e) => {
        if (player) {
          e.preventDefault();
          e.stopPropagation();
          player.playNew(playable);
        }
        onClick?.(e);
      }}
      {...props}
    />
  );
};
